import { Grid } from '@material-ui/core';
import React from 'react';


export default class InterpretareComponent1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

        if(!this.props.interpretare2){

            this.interpretare(this.props.val1, this.props.val2, this.props.cF1, this.props.cF2)
        }else{
            this.interpretare2(this.props.val1, this.props.val2, this.props.cF1, this.props.cF2)
        }
    }

    interpretare = (val1, val2 = null, cF1, cF2) => {


        if (val2 === null) {

            console.log('val1 :>> ', val1);
            console.log('cF1 :>> ', cF1);
            console.log('cF2 :>> ', cF2);
            if (val1 < cF1) {
                this.props.displayArrow('arrow1')
            } else if (val1 > cF1 && val1 < cF2) {
                this.props.displayArrow('arrow2')
            } else {
                this.props.displayArrow('arrow3')
            }
        }
    }


    interpretare2 =  (val1, val2 = null, cF1, cF2) => {


        if (val2 === null) {
            if (val1 > cF1) {
                this.props.displayArrow('arrow1')
            } else if (val1 < cF1 && val1 > cF2) {
                this.props.displayArrow('arrow2')
            } else {
                this.props.displayArrow('arrow3')
            }
        }
    }


    render() {
        return (

            <Grid container>
                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                    <div style={{
                        width: '100%',
                        backgroundColor: 'rgb(227 51 59)',
                        textAlign: 'center',
                        color: 'white',
                        fontSize: 12,
                        borderTopLeftRadius: 20,
                        borderBottomLeftRadius: 20,
                        position: 'relative',
                        padding: 5
                    }}>
                        {this.props.arrow1 &&
                            <i
                                style={{
                                    color: 'black',
                                    fontSize: 30,
                                    position: 'absolute',
                                    top: -23,
                                    left: 0,
                                    right: 0,
                                    margin: 'auto'
                                }}
                                className='material-icons'>arrow_drop_down</i>
                        }

                        {this.props.labels[0]}
                    </div>
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                    <div style={{
                        width: '100%',
                        backgroundColor: 'rgb(229 178 59)',
                        textAlign: 'center',
                        color: 'white',
                        fontSize: 12,
                        position: 'relative',
                        padding: 5
                    }}>
                        {this.props.arrow2 &&
                            <i
                                style={{
                                    color: 'black',
                                    fontSize: 30,
                                    position: 'absolute',
                                    top: -23,
                                    left: 0,
                                    right: 0,
                                    margin: 'auto'
                                }}
                                className='material-icons'>arrow_drop_down</i>
                        }
                        {this.props.labels[1]}
                    </div>
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                    <div style={{
                        width: '100%',
                        backgroundColor: 'rgb(86 133 26)',
                        textAlign: 'center',
                        color: 'white',
                        fontSize: 12,
                        borderTopRightRadius: 20,
                        borderBottomRightRadius: 20,
                        position: 'relative',
                        padding: 5
                    }}>
                        {this.props.arrow3 &&
                            <i
                                style={{
                                    color: 'black',
                                    fontSize: 30,
                                    position: 'absolute',
                                    top: -23,
                                    left: 0,
                                    right: 0,
                                    margin: 'auto'
                                }}
                                className='material-icons'>arrow_drop_down</i>
                        }

                        {this.props.labels[2]}
                    </div>
                </Grid>
            </Grid>

        );
    }
}





